"use strict";
/* eslint-disable prettier/prettier */
/**
 * AUTOGENERATED - DO NOT EDIT DIRECTLY
 *
 * Please see "scripts/regionalization/README.md" for how to modify
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AWS_REGION_MARKETS = void 0;
const aws_1 = require("../aws");
const country_code_1 = require("../country-code");
exports.AWS_REGION_MARKETS = {
    [aws_1.AwsRegions.APSE1]: [
        country_code_1.IsoCountryCode2Char.AU,
        country_code_1.IsoCountryCode2Char.KR,
        country_code_1.IsoCountryCode2Char.MY,
        country_code_1.IsoCountryCode2Char.NZ,
        country_code_1.IsoCountryCode2Char.PH,
        country_code_1.IsoCountryCode2Char.SG,
        country_code_1.IsoCountryCode2Char.TW,
    ],
    [aws_1.AwsRegions.EUC1]: [
        country_code_1.IsoCountryCode2Char.AE,
        country_code_1.IsoCountryCode2Char.AQ,
        country_code_1.IsoCountryCode2Char.AT,
        country_code_1.IsoCountryCode2Char.BH,
        country_code_1.IsoCountryCode2Char.CH,
        country_code_1.IsoCountryCode2Char.CZ,
        country_code_1.IsoCountryCode2Char.DE,
        country_code_1.IsoCountryCode2Char.EG,
        country_code_1.IsoCountryCode2Char.FR,
        country_code_1.IsoCountryCode2Char.GB,
        country_code_1.IsoCountryCode2Char.IE,
        country_code_1.IsoCountryCode2Char.KW,
        country_code_1.IsoCountryCode2Char.KY,
        country_code_1.IsoCountryCode2Char.MA,
        country_code_1.IsoCountryCode2Char.MU,
        country_code_1.IsoCountryCode2Char.NL,
        country_code_1.IsoCountryCode2Char.OM,
        country_code_1.IsoCountryCode2Char.PL,
        country_code_1.IsoCountryCode2Char.QA,
        country_code_1.IsoCountryCode2Char.RO,
        country_code_1.IsoCountryCode2Char.SA,
        country_code_1.IsoCountryCode2Char.ZA,
    ],
    [aws_1.AwsRegions.EUW3]: [
        country_code_1.IsoCountryCode2Char.AQ,
        country_code_1.IsoCountryCode2Char.ES,
        country_code_1.IsoCountryCode2Char.PT,
        country_code_1.IsoCountryCode2Char.IT,
    ],
    [aws_1.AwsRegions.USE1]: [
        country_code_1.IsoCountryCode2Char.AQ,
        country_code_1.IsoCountryCode2Char.CA,
        country_code_1.IsoCountryCode2Char.CH,
        country_code_1.IsoCountryCode2Char.GB,
        country_code_1.IsoCountryCode2Char.US,
        country_code_1.IsoCountryCode2Char.ZA,
    ],
    [aws_1.AwsRegions.USE2]: [
        country_code_1.IsoCountryCode2Char.AR,
        country_code_1.IsoCountryCode2Char.BR,
        country_code_1.IsoCountryCode2Char.CL,
        country_code_1.IsoCountryCode2Char.DO,
        country_code_1.IsoCountryCode2Char.MX,
        country_code_1.IsoCountryCode2Char.PR,
    ],
};
//# sourceMappingURL=aws-region.js.map